import React, { useEffect, useState } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink, Link, useLocation } from "react-router-dom";
import { getSubGallery } from '../Service/Api';
import LazyLoad from 'react-lazyload';

// Optional: Extracted ImageCard Component
const ImageCard = ({ img, index }) => (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
        <a
            data-magnify="gallery"
            data-group="a"
            data-src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
            href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
        >
            <LazyLoad height={200} offset={100} once placeholder={<div>Loading image...</div>}>
                <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`}
                    className="img-fluid mx-auto d-block"
                    alt={`Image ${index + 1}`}
                />
            </LazyLoad>
        </a>
    </div>
);

function SubGallery() {
    const location = useLocation();
    const id = new URLSearchParams(location.search).get('id');

    const [data, setData] = useState({
        attachments: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (id) {
                    const subgalleryData = await getSubGallery(id);
                    setData(subgalleryData || { attachments: [] });
                }
            } catch (error) {
                console.error('Error fetching subgallery data:', error);
                setData({ attachments: [] });
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const eventDate = data?.date
        ? new Date(data.date).toLocaleDateString('en-GB')
        : 'Not Available';

    if (loading) {
        return (
            <>
                <Header />
                <section className="inr-header">
                    <div className="container">
                        <div className="inr-header-content">
                            <h1 className="title">Sub Gallery</h1>
                            <ul className="breadcrumb">
                                <li><NavLink to="/">Home</NavLink></li>
                                <li> Sub Gallery</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section className="innerBody">
                    <div className="container text-center">
                        <p>Loading Sub Gallery...</p>
                    </div>
                </section>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />

            {/* Inner Header */}
            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">Sub Gallery</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Sub Gallery</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Sub Gallery</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="datedetails">
                                <span>Event Date: {eventDate}</span>
                                <span>Last Date: {eventDate}</span>
                                <span>Total Photos: {data.attachments.length}</span>
                                <span className="back">
                                    <Link to="/Gallery">
                                        <i className="bi bi-chevron-double-left"></i>
                                    </Link>
                                </span>
                            </div>

                            <div className="fulldesc">
                                <h3>{data.title}</h3>
                                <p>{data.description}</p>
                            </div>

                            <div className="clr10"></div>

                            <div className="row imgthumb">
                                {data.attachments.map((img, index) => (
                                    <ImageCard img={img} index={index} key={index} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="clr100"></div>

            <Footer />
        </>
    );
}

export default SubGallery;
